import React,{useState} from "react";
import { useHistory,useParams } from "react-router-dom";
import Main from "../../components/template/Main";
import useTable from "../../components/table/useTable";
import TableFooter from "../../components/table/TableFooter";
import {FiX,FiEdit2} from 'react-icons/fi';
import {get} from '../../store/config/register';
import { login_Id } from "../../store/config/dadosuser";

const headerProps = {
    icon: "users",
    title: "Pesquisa de Hospede",
  }

export default function PesquisaHospede() {

    const [pesquisa,setPesquisa] = useState('');
    const [visitantes,setVisitantes]=useState([]);
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(visitantes, page, 10);
    const history = useHistory();
    const {IdVisita} = useParams();
    

    function  updateField(event) {
        setPesquisa(event.target.value);
  }

  function clear () {
    setPesquisa('')
  }

 async function Pesquisar(){
   const pesq = await get(`/Visitante/v1/Pesquisa?AnfitriaoId=${login_Id}&nome=${pesquisa}`)
    if(pesq !== undefined){
        setVisitantes(pesq);
    }

  }

    function renderForm(){
        return (
            <div className="form"> 
                 <div className="nome-visitante">
                    <div className="form-group">
                    <label>Visitante:</label>
                    <input type="text" name="pesquisa" 
                    placeholder="pesquisa" 
                        className="form-control" value={pesquisa} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>

                <div id="botao">
                <button className="btn btn-success ml-2" onClick={e => {
                    if(IdVisita !== undefined){
                      history.push('/Acompanhante/'+IdVisita)
                    }else{
                      history.push('/Hospede/1')
                    }

                  } 
                  }>
                    Novo
                  </button>
                  <button  className="btn btn-primary ml-2" onClick={ async e => await Pesquisar()}>
                    Pesquisar
                  </button>
                </div>
                <hr /> 
                {renderTable()}
            </div>
        )
    }

    function renderTable(){
        return (
            <div className="tabela">
                <table>
                    <thead>
                        <tr>
                        <th scope="col">Nome</th>
                        </tr>
                    </thead>
                    <tbody>
                    {slice === undefined ? null :slice.map((item, index)=>{
                        return (
                    <tr key={index}>
                      <td data-label="Nome">{item.nome}</td>
                    <td  data-label="">
                      <button className="action" style={{backgroundColor: '#F99E08' ,marginRight: "20px" }} data-toggle="tooltip" data-placement="bottom" title="Editar" onClick={(e) =>
                         {
                          if(IdVisita !== undefined){
                            history.push('/Acompanhante/'+IdVisita+'/'+ item.id)
                           }else{
                            history.push('/Hospede/1?Visitante='+ item.id+"&Visita=0")
                           }
                         }
                         } >
                        <FiEdit2 color="#FFF" size={17} />
                        </button>
                        <button className="action" style={{backgroundColor: '#ff0000', marginTop: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Excluir Visitante"  onClick={async(e) => true} >
                        <FiX color="#FFF" size={17} />
                        </button>
                        </td>
                    </tr>
                        );

                    })}
                    </tbody>
                </table>
                <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
            </div>
        );
    }

    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}